import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "../login/login";
import "./demo.css";
import MainRoute from "../cram_school/MainRoute";
import MainRouteOfficialweb from "../official_web/MainRoute";
import Upload_ot from '../OMS/online_order_management/Upload_ot';
import { Helmet } from 'react-helmet';
import LineLogin from '../login/LineLogin';
import MainRouteThirdPay from './../third_pay/MainRoute'

const RouteOfficeWeb = ({
}) => {
    const mobile = localStorage?.getItem('mobile') || 'true';
    return (<>
        <Helmet>
            {mobile === 'true' &&
                <meta name="viewport" content="width=device-width, initial-scale=1" />
            }
        </Helmet>
        <BrowserRouter>
            <Routes>
                <Route path={'upload'}>
                    {/* <Route index element={<Login logo="OT" />} /> */}
                    <Route index element={<Upload_ot />} />
                </Route>
                <Route path={'login'}>
                    <Route index element={<Login logo="keyTravel" />} />
                </Route>
                <Route index element={<Navigate to="/officialweb/frontend" />} />
                <Route path={'/officialweb/*'} element={<MainRouteOfficialweb admin={false} prefixTitle = '國立高雄師範大學全英語與雙語教學推動中心'/>} />
                    {/* true是要登入的 false是只會剩下形象的前台 */}
                {/* </Route> */}
                <Route path={'line_login'}>
                    <Route index element={<LineLogin logo="keyTravel" line_login />} />
                </Route>
                <Route path={'/ThirdPay/*'} element={<MainRouteThirdPay />} />
                <Route path={'/cramSchool/*'} element={<MainRoute admin={false} />}>{/* true是要登入的 false是只會剩下形象的前台 */}
                </Route>

            </Routes>

                        {/* <MainRoute admin={true} /> */}
        </BrowserRouter >
    </>);
}
export default RouteOfficeWeb;
